export interface ContractState {
  isAccepted?: boolean;
  contractHtml?: string;
}

const contract: ContractState = {
  isAccepted: undefined,
  contractHtml: undefined,
};

export default contract;
